import { transformElements, ElementTypes } from '../../utils/html-util';
import { Fragment } from 'vue-fragment';
import Vue from 'vue';
export default Vue.extend({
    name: 'html-renderer',
    components: { Fragment },
    props: {
        htmlObject: {
            type: Object
        },
        onClick: {
            type: Function
        },
        getTextClass: {
            type: Function
        },
        isPickTheAnswer: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ElementTypes
        };
    },
    computed: {
        html() {
            return transformElements(this.htmlObject);
        }
    },
    methods: {
        maybeHighlightClass(index, element) {
            if (!this.getTextClass)
                return [''];
            return this.getTextClass(index, element);
        },
        maybeHandleOnClick(index) {
            if (!this.onClick)
                return;
            this.onClick(index);
        },
        elementNameSelector(name) {
            if (this.isPickTheAnswer) {
                return name && name != 'wrapper' && name != 'div' ? name : 'fragment';
            }
            return name && name != 'wrapper' ? name : 'div';
        }
    }
});
